





























import { Component, Mixins, Prop, Watch, Emit } from "vue-property-decorator";
import { PatientProfileItem } from "../../../../domain/patient";
import { ElTable } from "element-ui/types/table";

@Component({
  components: {
  },
})
export default class PatientProfileEditor extends Mixins() {
  // 手抜きして上位のコンポーネントに変更通知していないが、たぶんしたほうがいい
  @Prop()
  items: PatientProfileItem[];

  @Prop()
  selectedItem: PatientProfileItem;

  $refs!: {
    editor: ElTable
  };

  getCellStyleProperties(item: PatientProfileItem): any {
    return {
      padding: "0px",
      backgroundColor: (this.selectedItem === item) ? "orange" : null,
    };
  }

  getHeaderRowStyle(): any {
    return {
      textAlign: "center",
    };
  }

  @Emit()
  itemSelected(item: PatientProfileItem): void {}

  @Watch("items")
  onItemsUpdated(newValue: PatientProfileItem[], oldValue: PatientProfileItem[]) {
    // element-uiのテーブルにスクロールバーが表示される際、ヘッダがずれる問題に対応するため、dataプロパティ更新時に遅延でdoLayoutを呼び出す
    this.$nextTick(() => this.$doWhenValid(t => t.doLayout(), this.$refs.editor));
  }

  selectLastItem(item: PatientProfileItem): void {
    this.$refs.editor.setCurrentRow(item);
    const element = this.$refs.editor.$el.getElementsByClassName("el-table__body-wrapper")[0];
    element.scrollTop = element.scrollHeight;
  }
}
